import React from 'react';
type SunArcsProps = {
  className?: string;
};

/**
 * Sol de amanecer con arcos concéntricos — el motivo de portada de los
 * tomos DPS44. Hereda el color via `currentColor`.
 */
export function SunArcs({
  className
}: SunArcsProps) {
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true" className={className} data-id="element-337" data-mp="39y95273iv4ps">
      <circle cx="120" cy="120" r="30" fill="currentColor" stroke="none" opacity="0.55" data-id="element-338" data-mp="6g7qlf3juvqn" />
      <circle cx="120" cy="120" r="50" data-id="element-339" data-mp="be9bm5kjd54r" />
      <circle cx="120" cy="120" r="72" strokeDasharray="2 9" data-id="element-340" data-mp="3svaeq580tt02" />
      <circle cx="120" cy="120" r="94" data-id="element-341" data-mp="3sur4zbsiyax4" />
      <circle cx="120" cy="120" r="116" strokeDasharray="2 12" data-id="element-342" data-mp="1ozgegueb6cf" />
    </svg>;
}